import keplerGlReducer, {KeplerGlState} from '@kepler.gl/reducers';
import {Reducer} from "@reduxjs/toolkit";
import {VisStateExtension, visStatePlugin} from "./visStateActions";

export type ExtendedKeplerGlState = KeplerGlState & { visState: KeplerGlState['visState'] & VisStateExtension }

export const customizedKeplerGlReducer: Reducer<{
    map: ExtendedKeplerGlState;
}> = keplerGlReducer
    .initialState({
        mapStyle: {
            styleType: 'dark',
        },
        visState: {
            userKeplerStyleIdByLayerId: {},
            animationConfig: {
                speed: 0.05
            }
        }
    })
    .plugin({
        ...visStatePlugin
    });